import { render, staticRenderFns } from "./Yach4Customer.vue?vue&type=template&id=232b6e34"
import script from "./Yach4Customer.vue?vue&type=script&lang=js"
export * from "./Yach4Customer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports